import React, { FC } from 'react';

import CatIcon from '@rover/icons/svg/cat.svg';
import DogIcon from '@rover/icons/svg/dog.svg';
import PuppyIcon from '@rover/icons/svg/puppy.svg';
import useTheme from '@rover/kibble/themes/useTheme';
import PetTypeIcon from '@rover/react-lib/src/pages/search/SearchPage/components/ColorfulPerfectMatchSection/PetTypeIcon';
import { PetType } from '@rover/types/src/Pet';

import type { PetCounterIconVariant } from './PetCounterBody';

type Props = {
  petType: PetType;
  variant?: PetCounterIconVariant;
};

const defaultIconMap: Record<
  PetType,
  React.ComponentType<{ width: number; height: number; fill?: string }>
> = {
  [PetType.DOG]: DogIcon,
  [PetType.PUPPY]: PuppyIcon,
  [PetType.CAT]: CatIcon,
};

const PetCounterIcon: FC<Props> = ({ petType, variant = 'default' }) => {
  const theme = useTheme();

  if (variant === 'color') {
    return <PetTypeIcon petType={petType} />;
  }

  const Icon = defaultIconMap[petType];
  return <Icon width={24} height={24} fill={theme.textColor.secondary} />;
};

export default PetCounterIcon;
